import { CarrierSchema } from "@redotech/redo-fulfillment-carrier-common/carriers-and-services";
import { RateProvider } from "@redotech/redo-fulfillment-rate-common/outbound-labels";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const PickupAddressSchema = z.object({
  companyName: z.string().optional(),
  contactName: z.string(),
  addressLine: z.string(),
  room: z.string().optional(),
  floor: z.string().optional(),
  city: z.string(),
  stateProvince: z.string(),
  postalCode: z.string(),
  countryCode: z.string(),
  residentialIndicator: z.boolean().optional(),
  pickupPoint: z.string().optional(),
  phoneNumber: z.string(),
  phoneExtension: z.string().optional(),
});

export const createPickup = {
  name: "createPickup" as const,
  input: z.object({
    teamId: zExt.objectId(),
    name: z.string().optional(),
    carrier: CarrierSchema,
    provider: z.enum(RateProvider),
    pickupDate: z.string(),
    readyTime: z.string(),
    closeTime: z.string(),
    pickupAddress: PickupAddressSchema,
    packageCount: z.number(),
    totalWeight: z.object({
      weight: z.string(),
      unitOfMeasurement: z.enum(["LBS", "KGS"]),
    }),
    specialInstructions: z.string().optional(),
    referenceNumber: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    pickupRequestNumber: z.string().optional(),
    error: z.string().optional(),
  }),
};
